export enum LineType {
  LINE_TYPE_UNSET = 'LINE_TYPE_UNSET', // Do not use, needed because of proto3 limitations
  LINE_TYPE_MOBILITY = 'LINE_TYPE_MOBILITY',
  LINE_TYPE_MIFI = 'LINE_TYPE_MIFI',
}
